import { render, staticRenderFns } from "./MenPage.vue?vue&type=template&id=1745b166&scoped=true&"
import script from "./MenPage.vue?vue&type=script&lang=js&"
export * from "./MenPage.vue?vue&type=script&lang=js&"
import style0 from "./MenPage.vue?vue&type=style&index=0&id=1745b166&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1745b166",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
